import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function GarantiaSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-49">
      <div className="max-w-4xl mx-auto" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.3
      }} className="bg-brand-black text-white rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-51">
          {/* Background decoration */}
          <div className="absolute top-[-50%] left-[-10%] w-[50%] h-[100%] rounded-full bg-brand-orange/10 blur-3xl pointer-events-none" data-id="element-52"></div>

          <div className="relative z-10" data-id="element-53">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-brand-orange/20 text-brand-orange mb-8" data-id="element-54">
              <Shield className="w-10 h-10" data-id="element-55" />
            </div>

            <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6" data-id="element-56">
              Garantía de resultados
            </h2>

            <p className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto leading-relaxed mb-10" data-id="element-57">
              "Si aplicás el sistema durante 6 meses y no lográs escalar a
              $800.000/mes, te devolvemos el dinero."
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-58">
              <a href="#" className="w-full sm:w-auto bg-brand-orange text-brand-black font-bold text-lg px-10 py-4 rounded-xl shadow-lg hover:scale-[1.03] transition-transform text-center" data-id="element-59">
                Entrar con garantía
              </a>
              <a href="https://wa.me/5491100000000" className="w-full sm:w-auto text-white font-medium hover:text-brand-orange transition-colors text-center underline underline-offset-4" data-id="element-60">
                Resolver dudas ahora
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}